import * as THREE from 'three';
import gsap from 'gsap';
import { sceneObjects } from '../index';
import { cameraPos1, SCENE_OBJ_NAMES } from '../constants';
import { animationService } from './index';
import { cameraPositionAnimation } from '../camera';
import { threeJsSounds } from '../threeJsSounds';

const position = {
  x: 0,
  y: 0.021,
  z: 0,
};

export class Ball {
  constructor(glb) {
    this.model = glb.scene;
    this.ballMesh = this.model.getObjectByName('Sphere_2__Copy_1');
    this.model.position.set(position.x, position.y, position.z);
    this.mixer = new THREE.AnimationMixer(this.model);
    this.action = this.mixer.clipAction(glb.animations[0]);
    this.action.setLoop(THREE.LoopOnce);
    this.action.clampWhenFinished = true;
    this.clock = new THREE.Clock();
    this.animationDuration = this.action.getClip().duration;
    this.deviation = this.calculateDeviation();
    this.mixer.addEventListener('finished', (e) => {
      this.onAnimationFinished(e);
    });
    this.animate();
    this.addMaterialOnBallMesh();
  }

  getScene() {
    return sceneObjects.get(SCENE_OBJ_NAMES.scene);
  }

  playAnimation() {
    this.model.rotation.y = 0;
    this.action.reset().play();
  }

  addScene() {
    this.getScene()?.add(this.model);
  }

  removeFromScene() {
    this.getScene()?.remove(this.model);
  }

  animate() {
    requestAnimationFrame(() => {
      this.animate();
    });
    const delta = this.clock.getDelta();
    this.mixer.update(delta);
  }

  onAnimationFinished() {
    const camera = sceneObjects.get(SCENE_OBJ_NAMES.camera);
    animationService.setIsBallFollowerOnWheel(true);
    threeJsSounds.ballFinish();

    this.startGlitchEffect(() => {
      animationService.ballAnimationCallBack();
      cameraPositionAnimation(camera, cameraPos1);
    });
  }

  startGlitchEffect(onComplete) {
    const timeline = gsap.timeline({
      onComplete,
    });

    timeline.to(this.ballMesh.position, {
      x: '+=0.005',
      y: '+=0.002',
      z: '-=0.004',
      duration: 0.2,
      yoyo: true,
      repeat: 3,
      ease: 'power1.inOut',
    });
  }

  calculateDeviation() {
    const { x, z } = this.getAnimationFinishingPosition();
    return Math.atan2(z, x);
  }

  getAnimationFinishingPosition() {
    const { length } = this.action._clip.tracks[0].values;
    return {
      x: this.action._clip.tracks[0].values[length - 3],
      y: this.action._clip.tracks[0].values[length - 2],
      z: this.action._clip.tracks[0].values[length - 1],
    };
  }

  addMaterialOnBallMesh() {
    this.ballMesh.material = new THREE.MeshBasicMaterial({ color: 0xffffff });
  }

  stopAnimation() {
    this.action.stop();
  }
}
